// Lib
import { get } from 'lodash/fp';

// Util
import delay from '../../common/utils/lib/delay';
import globalLogger from '../logger/logger';

// Services
import { http } from '../utils/services/http';

// Actions
import { trackUsers } from './userActions';
import { updateCurrentUser } from './currentUserActions';

import { refreshMe } from './userService';
import { getSubscriptionId, getUserId } from '../../common/users/utils/userPropertyUtils';

// Selectors
import { getCurrentUserId } from './currentUserSelector';
import { getUsers } from './usersSelector';
import { refreshUser } from '../../common/users/userActions';

const logger = globalLogger.createChannel('current-user-subscription-actions');

let isFetchingSubscription = false;
export const fetchCurrentUserSubscription = () => async (dispatch, getState) => {
    if (isFetchingSubscription) return;
    isFetchingSubscription = true;

    try {
        const { data } = await http({
            url: 'users/me/subscription',
            timeout: 30000,
        });

        isFetchingSubscription = false;

        const userId = getCurrentUserId(getState());
        const { subscription, customer } = data;

        if (!subscription && !customer) return;

        dispatch(
            updateCurrentUser({
                userId,
                changes: {
                    subscriptionId: subscription?._id,
                    subscription,
                    customer,
                },
                sync: false,
            }),
        );

        const teamMembers = subscription?.teamMemberIds || [];
        if (teamMembers.length > 1) {
            const trackedUserIds = getUsers(getState());

            const untrackedTeamMembers = teamMembers.filter((teamMemberId) => !trackedUserIds.has(teamMemberId));

            const limitedUntrackedTeamMembers = untrackedTeamMembers.slice(0, 10);

            dispatch(trackUsers(limitedUntrackedTeamMembers));
        }

        return subscription;
    } catch (error) {
        isFetchingSubscription = false;
        logger.error('Failed to fetch current user subscription', error);
    }
};

const getResponseUser = get(['data', 'user']);
// This function ensures the contentLimit is updated when the user's subscription changes
export const refreshCurrentUserOnSubscriptionChange =
    ({ subscriptionId }) =>
    async (dispatch) => {
        let response = await refreshMe();
        let user = getResponseUser(response);
        let userSubscriptionId = getSubscriptionId(user);

        if (userSubscriptionId !== subscriptionId) {
            // Sensitive data audit: SAFE — error auto-sanitized (internal ids only)
            logger.warn('First attempt at refreshing the user failed', {
                userId: getUserId(user),
                subscriptionId,
            });

            await delay(500);

            // Try fetching the user again
            response = await refreshMe();
            user = getResponseUser(response);
            userSubscriptionId = getSubscriptionId(user);
        }

        if (userSubscriptionId !== subscriptionId) {
            // Sensitive data audit: SAFE — error auto-sanitized (internal ids only)
            logger.error('Failed to refresh user (final attempt)', {
                userId: getUserId(user),
                subscriptionId,
            });
        }

        dispatch(refreshUser({ userId: user._id, user }));
    };
